import {ControlBase} from "./control-base";

export class TextboxControl extends ControlBase<string> {
    override controlType = 'textbox';
}

export class DropdownControl extends ControlBase<string> {
    override controlType = 'dropdown';
}

export class DateControl extends ControlBase<string> {
    override controlType = "date";
}